var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireAlarmPanel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.52,13.52H2.48V2.48h11.03V13.52z M2.98,13.02h10.03V2.98H2.98V13.02z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.15,12.89 8,7.81 2.82,13  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.51,13.13L8,7.63l5.46,5.38L2.51,13.13z M8,7.98l-4.88,4.89l9.73-0.11L8,7.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.18,3 8.01,7.95 2.86,3.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.02,8.12L2.55,2.97L13.5,2.87L8.02,8.12z M3.17,3.22l4.84,4.56l4.85-4.65L3.17,3.22z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireAlarmPanel);
export default __webpack_public_path__ + "static/media/FireAlarmPanel.3058632a2ad0c1732d02a7c8eb004080.svg";
export { ForwardRef as ReactComponent };